import { cn } from '@/lib/utils';

interface BrandLogoProps {
  isLight?: boolean;
}

export function BrandLogo({ isLight = false }: BrandLogoProps) {
  return (
    <div className="flex items-center gap-2.5">
      <span
        className={cn(
          'relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-xl border',
          isLight
            ? 'border-cyan-300/70 shadow-[0_8px_22px_-16px_rgba(14,116,144,0.55)]'
            : 'border-cyan-400/30 shadow-[0_0_24px_-8px_rgba(34,211,238,0.52)]',
        )}
      >
        <span
          className={cn(
            'absolute inset-0',
            isLight
              ? 'bg-gradient-to-br from-[#176587] via-[#256f94] to-[#5f2d87]'
              : 'bg-gradient-to-br from-[#1d7ea3] via-[#2a86ad] to-[#7d3ab2]',
          )}
        />
        <span className="absolute inset-0 bg-[radial-gradient(circle_at_28%_24%,rgba(255,255,255,0.32),transparent_58%)]" />
        <svg
          viewBox="0 0 24 24"
          className="relative z-10 h-[18px] w-[18px]"
          aria-hidden
        >
          <path
            d="M16.8 5.2H9.6C7.9 5.2 6.8 6.3 6.8 7.9c0 1.4.9 2.3 2.5 2.8l3 .9c1 .3 1.5.6 1.5 1.4 0 .9-.7 1.4-1.9 1.4H6.7"
            fill="none"
            stroke="rgba(246,251,255,0.98)"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.2 18.8H10c-1.7 0-2.8-1.1-2.8-2.7"
            fill="none"
            stroke="rgba(246,251,255,0.98)"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <span className="font-['Syne',sans-serif] text-lg font-extrabold tracking-tight leading-none">
        <span
          className={cn(
            'bg-gradient-to-r bg-clip-text text-transparent',
            isLight
              ? 'from-[#176587] via-[#1f5f7f] to-[#24344d]'
              : 'from-cyan-200 via-slate-100 to-violet-200',
          )}
        >
          System
        </span>
        <span
          className={cn(
            'bg-gradient-to-r bg-clip-text text-transparent',
            isLight
              ? 'from-[#24344d] via-[#5a3a7d] to-[#7d3ab2]'
              : 'from-slate-100 via-fuchsia-200 to-violet-300',
          )}
        >
          Hub
        </span>
      </span>
    </div>
  );
}
